export default {
  taskMap: state => state.taskMap,
  isOpenCopyPopup: state => state.isOpenCopyPopup,
  hasCopiedTask: state => state.hasCopiedTask,
  copiedTask: state => state.copiedTask,
  copySettingsConfigsMap: state => state.copySettingsConfigsMap,
  popupCoordinates: state => state.popupCoordinates,
  isInsertingProcess: state => state.isInsertingProcess,
  copySettingsConfig: state => projectId => state.copySettingsConfigsMap[projectId],
  currentProjectId: state => state.currentProjectId,
  copyPastError: state => state.copyPastError,
};
